var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstantDisableModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1699 0.657816C9.12992 0.669889 0.17972 9.63968 0.191794 20.6797C0.203867 31.7197 9.17366 40.6699 20.2137 40.6578C31.2536 40.6457 40.2038 31.6759 40.1918 20.6359C40.1797 9.59594 31.2099 0.645743 20.1699 0.657816ZM22.2027 30.6556L18.2027 30.66L18.1983 26.66L22.1983 26.6556L22.2027 30.6556ZM22.194 22.6556L18.194 22.66L18.1808 10.66L22.1808 10.6556L22.194 22.6556Z",
    fill: "#29BCC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantDisableModal);
export default __webpack_public_path__ + "static/media/instant-disable-modal.52222bb4d38f64b933939f0849c2c020.svg";
export { ForwardRef as ReactComponent };